import { render, staticRenderFns } from "./Lp2.vue?vue&type=template&id=61001e74&scoped=true"
import script from "./Lp2.vue?vue&type=script&lang=js"
export * from "./Lp2.vue?vue&type=script&lang=js"
import style0 from "./Lp2.vue?vue&type=style&index=0&id=61001e74&prod&lang=scss"
import style1 from "./Lp2.vue?vue&type=style&index=1&id=61001e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61001e74",
  null
  
)

export default component.exports